import { useState } from "react";
import CustomerDetailsTemplate from "templates/users/customers/customerDetails";
import CustomerDetails from "components/Organisms/users/customers/details";
import CustomerOccasions from "components/Organisms/users/customers/customerOccasions";
import ComplainHistory from "components/Organisms/users/customers/complainHistory";
import OrderHistory from "components/Organisms/users/customers/orderHistory";
import { handleTabChange } from "services/modules/utils/Helper";
import { useTranslation } from "react-i18next";

export default function CustomerDetailsPage({
  details,
  actionsList,
  followers,
  followings,
}) {
  const { t } = useTranslation();
  const tabs = [
    {
      title: t("customers.tab_details"),
      children: (
        <CustomerDetails
          details={details}
          followers={followers}
          followings={followings}
        />
      ),
    },
    { title: t("customers.tab_occasions"), children: <CustomerOccasions /> },
    { title: t("customers.tab_orders_history"), children: <OrderHistory /> },
    {
      title: t("customers.tab_complaints_history"),
      children: <ComplainHistory />,
    },
  ];

  const [searchParams, setSearchParams] = useState(
    new URLSearchParams(window.location.search),
  );
  const selectedTab = searchParams.get("tab");
  const [value, setValue] = useState(+selectedTab || 0);

  return (
    <CustomerDetailsTemplate
      details={details}
      selectedTab={value}
      tabs={tabs}
      handleTabChange={(event, newValue) =>
        handleTabChange({
          event,
          newValue,
          setValue,
          searchParams,
          setSearchParams,
        })
      }
      actionsList={actionsList}
      followers={followers}
      followings={followings}
    />
  );
}
